import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Category } from '@/types/category';
import { useLanguage } from '@/context/LanguageContext';
import { Button } from '@/components/ui/button';

interface Props {
  title: string;
  subtitle: string;
  categories: Category[];
}

const CategoryShowcaseSection: React.FC<Props> = ({ title, subtitle, categories }) => {
  const { tl } = useLanguage();
  const displayCategories = categories.slice(0, 6);
  
  return (
    <section className="section flex flex-col bg-background overflow-hidden">
      <div className="container-custom flex flex-col h-full">
        <div className="flex-none mb-8">
          <h2 className="section-title text-center text-foreground">{title}</h2>
          <div className="flex flex-col md:flex-row md:items-center md:justify-center gap-4">
            <p className="text-muted-foreground max-w-2xl text-center md:text-left">{subtitle}</p>
            <Button asChild variant="luxury" size="sm" className="self-center">
              <Link to="/products">
                {tl('Voir plus', 'View more', 'Vedi di più')} <ArrowRight className="ml-1 w-4 h-4" />
              </Link>
            </Button>
          </div>
        </div>
        <div className="flex-1 w-full">
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 lg:gap-x-6 lg:gap-y-6 w-full">
            {displayCategories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.name}`}
                className="relative rounded-2xl overflow-hidden shadow-lg group aspect-square md:aspect-square w-full flex"
              >
                <img
                  src={cat.image || '/placeholder.svg'}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-2 left-2 z-10 flex items-center gap-2">
                  <span className="text-white text-base md:text-lg font-semibold drop-shadow-lg bg-black/40 px-2 md:px-3 py-1 rounded-lg">{cat.name}</span>
                </div>
                <span className="absolute bottom-2 right-2 bg-white text-black rounded-full p-2 shadow-md flex items-center justify-center group-hover:bg-black group-hover:text-white transition-colors duration-300 z-10">
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5" />
                </span>
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent z-0" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CategoryShowcaseSection; 